import { MembershipBillingPlan } from "@app/shared/types";
import makeStyles from "@mui/styles/makeStyles";
import { PricingCard } from "./PricingCard";
import { getCurrentCohort } from "features/signup/signupHelpers";
import { BRAND_NAME } from "@app/shared/constants";

const slidingScaleDisplayDetails = [
    {
        title: "Supported rate: ",
        description: `Be supported by other members and by ${BRAND_NAME} because this is all you can afford based on your circumstances or local currency.`,
    },
    { title: "Base rate: ", description: "Covers your membership." },
    {
        title: "Supporting rate: ",
        description: "Support members who can’t afford a membership and our teachers.",
    },
];

export interface PricingCardBillingOptionsProps {
    billingPlanOptions: MembershipBillingPlan[];
    value: MembershipBillingPlan;
    onChange: (plan: MembershipBillingPlan) => void;
}

const useStyles = makeStyles((theme) => ({
    priceOptions: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(2.5),
        marginBottom: theme.spacing(3),
    },
}));

export const PricingCardBillingOptions = (props: PricingCardBillingOptionsProps) => {
    const classes = useStyles(props);

    const handlePlanSelection = (plan: MembershipBillingPlan) => {
        props.onChange(plan);
    };

    const cohort = getCurrentCohort();
    const isCohortSponsored = cohort !== null;

    const cohortSponsoredDisplayDetails = {
        description: `Your membership is free for the next 60 days thanks to our partnership with ${cohort}. Enjoy this gift of support knowing you can cancel at anytime.`,
    };

    if (isCohortSponsored) {
        return (
            <div className={classes.priceOptions}>
                <PricingCard
                    plan={props.billingPlanOptions[1]}
                    displayDetails={cohortSponsoredDisplayDetails}
                    onSelect={handlePlanSelection}
                    isSelected={true}
                />
            </div>
        );
    }

    return (
        <div className={classes.priceOptions}>
            {props.billingPlanOptions.map((plan, index) => (
                <PricingCard
                    key={index}
                    plan={plan}
                    displayDetails={slidingScaleDisplayDetails[index]}
                    onSelect={handlePlanSelection}
                    isSelected={props.value && plan.baseAmount === props.value.baseAmount}
                />
            ))}
        </div>
    );
};
